import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, IMonthlyOrdersListItem } from '../interfaces';
import { getMonthlyOrdersList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class MonthlyOrdersStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getMonthlyOrdersList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: MonthlyOrdersStore;
    public static getInstance(): MonthlyOrdersStore {
        if (!MonthlyOrdersStore.instance) {
            MonthlyOrdersStore.instance = new MonthlyOrdersStore();
        }
        return MonthlyOrdersStore.instance;
    }

    @observable list: IMonthlyOrdersListItem[] = [];
    @action setList(list: IMonthlyOrdersListItem[]): void {
        this.list = list;
    }

    @action cleanStore(): void {
        this.list = [];
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        companyId: true,
        dateMonth: [60, 0],
        pageNumber: true,
        pageSize: true,
        search: true,
        status: true,
    };
}
